export const CampaignStatus = {
    1: "Chuẩn bị",
    2: "Đang chạy",
    3: "Tạm dừng",
    4: "Kết thúc"
}

export const PageOptions = [10, 20, 50, 100, 200, 500, 1000, 5000]

export const FORMAT_DATE_FULL_TIME = 'DD/MM/YYYY HH:mm:ss'
